export const DEFAULT_DONUT_CHART_COLORS = ['#6AC7F699', '#22C9AD99', '#3AB0C599', '#5F89EC99', '#1E90FF99', '#4682B499'];